export function debounce (func, wait, immediate = true) {
  console.log(func)
  let timeout
  return function () {
    if (timeout) clearTimeout(timeout)
    if (immediate) {
      var callNow = !timeout
      timeout = setTimeout(() => {
        timeout = null
      }, wait)
      if (callNow) func.apply(this, arguments)
    } else {
      timeout = setTimeout(function () {
        // eslint-disable-next-line no-undef
        func.apply(context, args)
      }, wait)
    }
  }
}
export function throttle (fn, interval) {
  let timer = null // 定时器
  let firstTime = true // 判断是否是第一次执行
  // 利用闭包
  return function () {
    // 拿到函数的参数数组
    const args = Array.prototype.slice.call(arguments, 0)
    // 拿到当前的函数作用域
    const _this = this
    // 如果是第一次执行的话，需要立即执行该函数
    if (firstTime) {
      // 通过apply，绑定当前函数的作用域以及传递参数
      fn.apply(_this, args)
      // 修改标识为null，释放内存
      firstTime = null
      return
    }
    // 如果当前有正在等待执行的函数则直接返回
    if (timer) return
    // 开启一个倒计时定时器
    timer = setTimeout(function () {
      // 通过apply，绑定当前函数的作用域以及传递参数
      fn.apply(_this, args)
      // 清除之前的定时器
      timer = null
      // 默认1000ms执行一次
    }, interval)
  }
}



// WEBPACK FOOTER //
// ./src/utils/throttle.js